export default class PricingService {
    constructor(requestService) {
        this._request = requestService;
        this._pricingRanges = null;
        this._currentPricingRange = null;
        this._minumumGoalLimitToGetPricing = 10;
    }

    loadPricing(callback) {
        var self = this;
        this._getPricing(function () {
            self._loadPricingRange(callback);
        });
    }

    _getAddOnCost(goal) {
        if (this._isSpecialPrintProduct() && this._productHasSpecialPrintCosts() && goal <= 20) {
            return this._getProductSpecialCost() / goal;
        }
        return 0.00;
    }

    calculatePricing(product, goal, totalColorCount, frontColorCount, backColorCount, forceDTG) {
        this._setProduct(product);
        this._setPricingRangeByGoal(goal);

        // forceDTG = (goal <= 10 || forceDTG);

        var finalPrice = 0.00;

        if (this._isNonApparelProduct()
            || this._isSublimationProduct()
            || this._isPhoneCaseProduct()
            || this._isEmbroideryProduct()
            || (this._isSublimationProduct() && this._isSpecialPrintProduct())
            || forceDTG) {
            if ((this._isSublimationProduct() && this._isPhoneCaseProduct() === false)
                || (this._isSublimationProduct() === false && this._isSpecialPrintProduct() && this._isEmbroideryProduct() === false)) {
                if (frontColorCount > 0 && backColorCount > 0) {
                    finalPrice = this._getProductCost() + this._getSublimationPriceForDoubleSidePrint();
                } else {
                    finalPrice = this._getProductCost() + this._getSublimationPriceForSingleSidePrint();
                }
            } else {
                if (this._isEmbroideryProduct()) {
                    finalPrice = this._getProductCost() + this._getEmbroideryPrice();
                } else {
                    finalPrice = this._getProductCost() + this._getAppDTGPrice();

                    if (frontColorCount > 0 && backColorCount > 0) {
                        finalPrice = finalPrice + Math.ceil(this._getAppDTGPrice() / 2);
                    }
                }
            }
        } else {
            if (totalColorCount === 0) {
                finalPrice = (this._getProductCost() + (this._getCampaignPrice() / goal)) * ((100 + this._getAppMarkupPercentage()) / 100);
            } else {
                finalPrice = (this._getProductCost() + (this._getCampaignPrice() / goal) +
                    (((this._getScreenPrice() * frontColorCount) / goal) + this._getColorCostByCount(frontColorCount)) +
                    (((this._getScreenPrice() * backColorCount) / goal) + this._getColorCostByCount(backColorCount))) * ((100 + this._getAppMarkupPercentage()) / 100);
            }
        }

        finalPrice += this._getAddOnCost(goal);
        return finalPrice;
    }

    _loadPricingRange(callback) {
        var self = this;
        this._request.get(this._request.ajaxBase + 'printer-pricing-ranges', {}, (response)=> {
            var res = response.data;
            if (res.status == 'SUCCESS') {
                self._pricingRanges = res.data;

                if (callback)
                    callback(self._pricingRanges);
            }
        });
    }

    _setPricingRangeByGoal(goal) {
        var ranges = this._pricingRanges,
            self = this;

        if (goal < self._minumumGoalLimitToGetPricing) {
            goal = self._minumumGoalLimitToGetPricing;
        }
        this._currentPricingRange = _.find(ranges, function (range) {
            return (range.quantity_min <= goal && range.quantity_max >= goal);
        });
    }

    _getPricing(callback) {
        var goal = 10,
            self = this;
        this._request.get(self._request.ajaxBase + 'pricing', {goal: goal}, (response)=> {
            self.setAppPricing(response.data);
            if (callback)
                callback();
        })
    }

    setAppPricing(appPricing) {
        this._appPricing = appPricing;
    }

    _setProduct(product) {
        this._product = product;
    }

    _getAppMarkupPercentage() {
        return parseInt(this._appPricing['APP_PRICING']['MARKUP_PERCENTAGE']);
    }

    _getAppDTGPrice() {
        return parseFloat(this._appPricing['DTG_PRICE']);
    }

    _getScreenPrice() {
        return parseFloat(this._appPricing['SCREEN_CHARGE']);
    }

    _getCampaignPrice() {
        return parseFloat(this._appPricing['CAMPAIGN_PRICE']);
    }

    _getColorCostByCount(count) {
        if (count == 0)
            return 0.00;
        return parseFloat(this._currentPricingRange['colors_' + count]);
    }

    _getEmbroideryPrice() {
        return parseFloat(this._appPricing['EMBROIDERY_PRICE']);
    }

    _isNonApparelProduct() {
        return Boolean(this._product.is_non_apparel) === true;
    }

    _isSublimationProduct() {
        return Boolean(this._product.sublimation) === true;
    }

    _isPhoneCaseProduct() {
        return Boolean(this._product.is_phone_case) === true;
    }

    _isEmbroideryProduct() {
        return Boolean(this._product.is_embroidery) === true;
    }

    _isSpecialPrintProduct() {
        return Boolean(this._product.special_printing) === true;
    }

    _productHasSpecialPrintCosts() {
        return parseFloat(this._product.special_print_setup_costs) > 0;
    }

    _getSublimationPriceForSingleSidePrint() {
        return parseFloat(this._product.sublimation_single_side_price);
    }

    _getSublimationPriceForDoubleSidePrint() {
        return parseFloat(this._product.sublimation_double_side_price);
    }

    _getProductCost() {
        return parseFloat(this._product.avg_cost);
    }

    _getProductSpecialCost() {
        return parseFloat(this._product.special_print_setup_costs);
    }
}


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/services/PricingService.js